import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { apis } from '@/config';
export class TimeoutRangeInterceptor {
    constructor(interceptors) {
        this.dataTrackerApi = masterApi.requireLogicalApi(apis.dataTrackerApiImp);
        this.timeoutErrorCount = 0;
        this.timeoutErrorMap = new Map();
        this.bgNotExistErrorCount = 0;
        const [, interceptor] = interceptors;
        interceptor.use({
            namespace: 'common',
            type: 'error',
            resolve: async (response) => response,
            reject: async (error) => {
                setTimeout(() => {
                    this.recordCommonErrorLog(error);
                }, 20);
                throw error;
            },
        });
    }
    recordCommonErrorLog(error) {
        const code = typeof error === 'string' ? error : lodashGet(error, 'message', '');
        if (code.indexOf('API_RESPONSE_TIMEOUT') !== -1) {
            this.timeoutErrorCount += 1;
            const errkey = [lodashGet(error, 'config.namespace', ''), lodashGet(error, 'config.apiname', '')].join('-');
            this.timeoutErrorMap.set(errkey, (this.timeoutErrorMap.get(errkey) || 0) + 1);
            if (this.timeoutErrorCount <= TimeoutRangeInterceptor.MaxGrandCount) {
                return;
            }
            this.dataTrackerApi.track('pc_bridge_timeout_error', {
                path: location.pathname,
                msg: JSON.stringify(Object.fromEntries(this.timeoutErrorMap)),
            });
            this.timeoutErrorCount = 0;
            this.timeoutErrorMap.clear();
        }
        else if (code.indexOf('BG_WIN_NOT_EXIST') !== -1) {
            this.bgNotExistErrorCount += 1;
            if (this.bgNotExistErrorCount <= TimeoutRangeInterceptor.MaxGrandCount) {
                return;
            }
            this.dataTrackerApi.track('pc_bridge_notexist_error', {
                path: location.pathname,
            });
            this.bgNotExistErrorCount = 0;
        }
    }
    eject() { }
}
TimeoutRangeInterceptor.MaxGrandCount = 20;
